import api from '../utils/api';

export interface MaterialMRP {
  mrp_id: number;
  mat_id: number;
  variant_id: number | null;
  mat_code: string;
  mat_name: string;
  category: string;
  brand_name: string | null;
  variant_name: string | null;
  quality_tier: string | null;
  week_start_date: string;
  net_quantity: number;
  wastage_quantity: number;
  order_quantity: number;
  unit_of_measure: string;
  required_by_date: string;
  dispatch_by_date: string;
  best_supplier_id: number | null;
  supplier_name: string | null;
  supplier_mobile: string | null;
  supplier_email: string | null;
  estimated_cost: number | null;
  status: string;
  supplier_notified: boolean;
  notification_date: string | null;
  activity_ids: number[];
}

export interface ManpowerMRP {
  mrp_id: number;
  skill_code: string;
  skill_name: string | null;
  skill_category: string | null;
  week_start_date: string;
  workers_required: number;
  days_required: number;
  best_contractor_id: number | null;
  contractor_name: string | null;
  contractor_mobile: string | null;
  status: string;
  contractor_notified: boolean;
  notification_date: string | null;
}

export interface MachineryMRP {
  mrp_id: number;
  mch_type: string;
  week_start_date: string;
  days_required: number;
  hours_per_day: number;
  quantity_needed: number;
  status: string;
  vendor_notified: boolean;
  notification_date: string | null;
}

export interface ToolsMRP {
  mrp_id: number;
  tls_category: string;
  week_start_date: string;
  quantity_needed: number;
  status: string;
}

export interface DelaySummary {
  delayed_activities: number;
  completed: number;
  in_progress: number;
  avg_delay_days: number;
  max_delay_days: number;
}

// Material MRP
export const getMaterialMRP = (projectId: number) =>
  api.get('/mrp/material', { params: { project_id: projectId } }).then((r: any) => r.data.data as MaterialMRP[]);
export const generateMaterialMRP = (projectId: number) =>
  api.post('/mrp/material/generate', { project_id: projectId }).then((r: any) => r.data);
export const notifyMaterialSupplier = (mrpIds: number[]) =>
  api.post('/mrp/material/notify', { mrp_ids: mrpIds }).then((r: any) => r.data);
export const reviseMaterialMRP = (projectId: number) =>
  api.post('/mrp/material/revise', { project_id: projectId }).then((r: any) => r.data);

// Manpower MRP
export const getManpowerMRP = (projectId: number) =>
  api.get('/mrp/manpower', { params: { project_id: projectId } }).then((r: any) => r.data.data as ManpowerMRP[]);
export const generateManpowerMRP = (projectId: number) =>
  api.post('/mrp/manpower/generate', { project_id: projectId }).then((r: any) => r.data);

// Machinery MRP
export const getMachineryMRP = (projectId: number) =>
  api.get('/mrp/machinery', { params: { project_id: projectId } }).then((r: any) => r.data.data as MachineryMRP[]);
export const generateMachineryMRP = (projectId: number) =>
  api.post('/mrp/machinery/generate', { project_id: projectId }).then((r: any) => r.data);

// Tools MRP
export const getToolsMRP = (projectId: number) =>
  api.get('/mrp/tools', { params: { project_id: projectId } }).then((r: any) => r.data.data as ToolsMRP[]);
export const generateToolsMRP = (projectId: number) =>
  api.post('/mrp/tools/generate', { project_id: projectId }).then((r: any) => r.data);

// Delay
export const getDelaySummary = (projectId: number) =>
  api.get('/mrp/delay-summary', { params: { project_id: projectId } }).then((r: any) => r.data.data as DelaySummary);
